import script from "./D3BarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./D3BarChart.vue?vue&type=script&setup=true&lang=js"

import "./D3BarChart.vue?vue&type=style&index=0&id=2df4f5b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df4f5b3"]])

export default __exports__